export enum InvoiceRequestStatus {
    Normal = 'normal',
    Removed = 'removed'
}

export interface InvoiceRequest {
    id: number;
    productName: string;
    companyName: string;
    customerEmail: string;
    amount: number;
}
